import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'
import { HelpMessage } from 'utils/constants'
import { Issue } from '../../../../../IssueTrackerContext/types'
import { IssueStatus } from '@cims-online/shared'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

export const Description: React.VFC<Pick<Issue, 'statusId'>> = ({
  statusId,
}) => {
  const [disabled, { some }] = useDisabledOptions([
    {
      disabled: statusId === IssueStatus.Closed.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Closed.name },
    },
  ])
  return (
    <CIMSFormItem
      name="description"
      label="Description"
      requiredMessage={
        statusId === IssueStatus.Draft.id
          ? undefined
          : 'Please enter a description'
      }
      disabled={disabled}
      help={HelpMessage.Issues.IssueTracker.Description}
    >
      <CIMSTextArea maxLength={2000} disabled={some} />
    </CIMSFormItem>
  )
}
